import React from "react";
import { FaEye } from "react-icons/fa";

/**
 * Banner del modo "Ver como residente" (herramienta de admin).
 * Deja claro que es una vista de solo lectura y no la sesión del residente,
 * con botón para salir y volver al panel admin.
 */
export default function ViewAsResidentBanner({ target, onExit }) {
  const name = target?.name || target?.email || "residente";
  return (
    <div style={S.bar}>
      <span style={S.text}>
        <FaEye size={13} style={{ marginRight: 6, verticalAlign: "-2px" }} />
        Estás viendo como <strong>{name}</strong> · SOLO LECTURA — no es su sesión.
      </span>
      <button type="button" onClick={onExit} style={S.btn}>Salir de la vista</button>
    </div>
  );
}

const S = {
  bar: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    padding: "9px 16px",
    background: "linear-gradient(90deg, #0066cc 0%, #0080ff 100%)",
    color: "#fff",
    fontSize: 13.5,
  },
  text: { lineHeight: 1.3 },
  btn: {
    flexShrink: 0,
    padding: "7px 14px",
    borderRadius: 8,
    border: "1px solid rgba(255,255,255,0.4)",
    background: "rgba(255,255,255,0.12)",
    color: "#fff",
    cursor: "pointer",
    fontSize: 13,
    fontWeight: 400,
  },
};
